import { STORAGE_KEYS } from '../config/constants';

export class StorageUtils {
  
  static get(key: string): string | null {
    try {
      return localStorage.getItem(key);
    } catch (error) {
      console.error('Error reading from localStorage:', error);
      return null;
    }
  }

  static set(key: string, value: string): void {
    try {
      localStorage.setItem(key, value);
    } catch (error) {
      console.error('Error writing to localStorage:', error);
    }
  }

  static remove(key: string): void {
    try {
      localStorage.removeItem(key);
    } catch (error) {
      console.error('Error removing from localStorage:', error);
    }
  }

  static clear(): void {
    try {
      localStorage.clear();
    } catch (error) {
      console.error('Error clearing localStorage:', error);
    }
  }


  static getAuthToken(): string | null {
    return this.get(STORAGE_KEYS.AUTH_TOKEN);
  }

  /**
   * Set admin token
   */
  static setAuthToken(token: string): void {
    this.set(STORAGE_KEYS.AUTH_TOKEN, token);
  }

  /**
   * Remove admin token
   */
  static removeAuthToken(): void {
    this.remove(STORAGE_KEYS.AUTH_TOKEN);
  }
}